import { render, staticRenderFns } from "./ProductInOrder.vue?vue&type=template&id=62f6615a&scoped=true&"
import script from "./ProductInOrder.vue?vue&type=script&lang=js&"
export * from "./ProductInOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProductInOrder.vue?vue&type=style&index=0&id=62f6615a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f6615a",
  null
  
)

export default component.exports